import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_URL = process.env.REACT_APP_API_URL;

export const consultaAlumnoApi = createApi({
    reducerPath: 'consultaAlumnoApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.userInfo.token;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (build) => ({
        obtenerAlumno: build.query({
            query: ({ numeroControl, nombre }) => `alumnos/json/data/filter?numeroControl=${numeroControl}&nombre=${nombre}`
        }),
    }),
});
export const { useObtenerAlumnoQuery } = consultaAlumnoApi;